import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { FlyoutTodayComponent } from './flyout-today.component';

@NgModule({
  imports: [CommonModule, HttpClientModule, ModalModule.forRoot()],
  declarations: [FlyoutTodayComponent],
  exports: [FlyoutTodayComponent]
})
export class FlyoutTodayModule {}
